import Cookie from "js-cookie";
import { debounce } from "../utils";
import GAService from "./GAService";
import Player from "@vimeo/player";

export default class LeaveModal {
  constructor() {
    if (
      !document.getElementById("pricing_page") &&
      !document.getElementById("agencies_page") &&
      !document.getElementById("marketplace-hp") &&
      !document.getElementById("single-marketplace")
    ) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    this.player = null;
    

    this.$modal = $("#leave-modal");

    // quickfix, change it to data attribute or sth
    if(document.getElementById("pricing_page")) {
      this.modalPage = "PricingPage"
    }
    if(document.getElementById("agencies_page")) {
      this.modalPage = "AgenciesPage"
    }
    if(document.getElementById("marketplace-hp")) {
      this.modalPage = "MarketplaceHpPage"
    }
    if(document.getElementById("single-marketplace")) {
      this.modalPage = "MarketplaceSinglePage"
    }

    // this.modalPage = document.getElementById("pricing_page")
    //   ? "PricingPage"
    //   : "AgenciesPage";

    if (this.$modal.length === 0) {
      return;
    }

    // disable modal on marketplace hp if user comes from voluum panel
    if(urlParams.get('utm_source') === 'voluum-panel' && urlParams.get('utm_medium') === 'button') {
      Cookie.set(this.getCookieName(), "closed", { expires: 7 });
      return;
    }

    // disable popup on single marketplace pages if it was disabled on marketplace hp
    if(document.getElementById("single-marketplace") && Cookie.get('LeaveModalMarketplaceHpPage') === "closed") {
      return;
    }

    if ($(window).width() >= 768) {
      this.init();
    }
  }

  init() {
    const cookieValue = Cookie.get(this.getCookieName());

    if (cookieValue == "closed" || cookieValue == "submitted") {
      return;
    }

    GAService.sendEvent("leave-modal", "initialized", this.modalPage);

    setTimeout(() => {
      this.handleHovers();
      this.handleModalOpen();
      this.handleSubmit();
      this.handleClose();
    }, 7000);
  }

  setupVideos() {
    // window._wq = window._wq || [];
    const neutralVideo = this.$modal.find(`.leave-modal-video[data-state="neutral"]`);
    const happyVideo = this.$modal.find(`.leave-modal-video[data-state="happy"]`);
    const sadVideo = this.$modal.find(`.leave-modal-video[data-state="sad"]`);
    
    this.videos = {
      'neutral': {
        'id': `https://player.vimeo.com/video/${neutralVideo.attr("id").split("/")[0]}?h=${neutralVideo.attr("id").split("/")[1]}`,
        '$video': neutralVideo
      },
      'happy': {
        'id': `https://player.vimeo.com/video/${happyVideo.attr("id").split("/")[0]}?h=${happyVideo.attr("id").split("/")[1]}`,
        '$video': happyVideo
      },
      'sad': {
        'id': `https://player.vimeo.com/video/${sadVideo.attr("id").split("/")[0]}?h=${sadVideo.attr("id").split("/")[1]}`,
        '$video': sadVideo
      }
    };


    // this.changeVideo('neutral');
    this.loadVideosAndPlayFirst();
  }

  loadVideosAndPlayFirst() {
    const states = Object.keys(this.videos);

    for (let i = 0; i < states.length; i++) {
      let state = states[i];
      const $video = this.videos[state].$video;

      this.player = new Player($video.attr("id"), {
        id: this.videos[state].id,
        width: 1200,
        responsive: true,
        controls: false,
        muted: true,
        loop: true,
      });

      if (i === 0) {
        $video.addClass('leave-modal-video--show');
        this.player.play();
        this.currentVideoState = state;
      } else {
        this.player.setCurrentTime(1);
      }

      this.videos[state].handle = this.player;
    }
  }

  playVideo(state) {
    this.videos[state].$video.addClass('leave-modal-video--show');
    this.videos[state].handle.play();
    this.currentVideoState = state;
  }

  handleClose() {
    const { $modal } = this;

    $modal.find("[data-close-modal]").click(() => {
      this.close();
    });
  }

  close() {
    const { $modal } = this;

    Cookie.set(this.getCookieName(), "closed", { expires: 7 });

    $modal.removeClass("leave-modal--animation");

    setTimeout(() => {
      $modal.removeClass("leave-modal--visible");

      $modal.on(
        "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
        () => {
          $modal.removeClass("leave-modal--open");
        }
      );

      $("header").removeClass("leave-modal-is-open");
      $("#main section").removeClass("leave-modal-is-open");
    }, 500);

    const $body = $("body");
    $body.removeClass("leave-modal-is-open");
    $("html").removeClass("leave-modal-is-open");

    // scrolling problem fix below
    let scrollTop = parseInt($body.css("top")) * -1;

    $body.css("top", 0);
    $body.css("position", "inherit");

    $(document).scrollTop(scrollTop);
  }

  handleModalOpen() {
    $("html").on("mouseleave", () => {
      const cookieValue = Cookie.get(this.getCookieName());

      if (cookieValue !== "closed" && cookieValue !== "submitted") {
        this.setupVideos();
        this.open();
      }
    });
  }

  handleHovers() {
    this.$modal.find("[data-hover-state]").on("mouseover", "", (e) => {
      e.stopPropagation();
      this.changeVideo($(e.currentTarget).data("hoverState"));
    });

    this.$modal.find(".leave-modal__bg").on("mouseover", (e) => {
      e.stopPropagation();
      this.changeVideo("neutral");
    });

    this.$modal.find(".leave-modal__videos-overlay").on("mouseover", (e) => {
      e.stopPropagation();
      this.changeVideo("neutral");
    });
  }

  handleSubmit() {
    // delegate click event to wait until hubspot script is loaded
    $("#leave-form").on("click", ".leave-modal-submit-btn", () => {
      Cookie.set(this.getCookieName(), "submitted", { expires: 365 });
    });
  }

  changeVideo(state) {
    let { currentVideoState } = this;


    if (currentVideoState !== state) {
      GAService.sendEvent("leave-modal", "video-changed", state);

      if (typeof currentVideoState !== "undefined") {

        if (this.videos[currentVideoState].handle) {
          this.videos[currentVideoState].handle.pause();
          this.videos[currentVideoState].handle.setCurrentTime(0);
        }

        this.videos[currentVideoState].$video.removeClass("leave-modal-video--show");
      }

      if (this.videos[state].handle) {
        this.playVideo(state);
      }
    }
  }

  open() {
    this.opened = true;
    const { $modal } = this;

    GAService.sendEvent("leave-modal", "opened", "");

    $modal.addClass("leave-modal--open");
    $modal.addClass("leave-modal--animation");

    setTimeout(() => {
      $modal.addClass("leave-modal--visible");
    }, 1);

    const $body = $("body");
    $body.addClass("leave-modal-is-open");
    $("html").addClass("leave-modal-is-open");
    $("header").addClass("leave-modal-is-open");
    $("#main section").addClass("leave-modal-is-open");

    // scrolling problem fix below
    $body.css("top", $(document).scrollTop() * -1 + "px");
    $body.css("position", "fixed");
  }

  getCookieName() {
    return "LeaveModal" + this.modalPage;
  }
}
